import type { FaireProductEntity } from "../../entity_types/product";

export const p_kdz9fw5mq5: FaireProductEntity = {
  token: "p_kdz9fw5mq5",
  type: "product",
  name: "18K Gold Stainless Steel Modern Sculptural Statement Rings",
  brandToken: "b_wxdny9yjk7",
  brandName: "Norelle",
  imageUrl:
    "https://cdn.faire.com/fastly/d8d4ab10d24b3991607d2e531e7984704b6f7d8a8711361339e5f41be2ffe4a5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2999313b47e5eb8ca99fa7fbc9d693479d039f08802b5cbebfaa93bcb070a992.jpeg",
    "https://cdn.faire.com/fastly/1df407f99363f1085259cb1a99bdfff87eb891b9384aef55c14b32c6210cee1b.jpeg",
    "https://cdn.faire.com/fastly/6ac3d80d8c6deed2b8373e5dcfd6726c7ef9ae9427da86e2ce04e9b718de1524.jpeg",
    "https://cdn.faire.com/fastly/3699faf551b90f858fbeb01869db9ee1b0507c71718858cc767550fef6e3fa64.jpeg",
    "https://cdn.faire.com/fastly/a6766800486bb5847237ce0a85e02c027358ef813087efb945adcce140320aa5.jpeg",
    "https://cdn.faire.com/fastly/754c07129d5f9eae99c4e43e25cd8b79b1f4a9754701cc40d88c26cff0c9036c.jpeg",
    "https://cdn.faire.com/fastly/ba59dfee44e005967e613b94fbaa3a11b99b5b1c795895c9997c24877b239c69.jpeg",
    "https://cdn.faire.com/fastly/0997d00b33d1f7c68a638a0a20e42394469ac3a2c3ff8cc3e7535e89c0835d64.jpeg",
    "https://cdn.faire.com/fastly/e761fa5502680885fec280e6edd850cd09e6758c327d49a69472a106c4881148.jpeg",
  ],
  priceDollars: 5.8,
  description:
    "JDR0104020 – Cross Open Ring with Marquise CZ: 1.19 cm × 1.83 cm (0.46 in × 0.72 in), Weight 2.8 g (0.10 oz)\n\nJDR0104021 – Wave Curve Ring with Pear CZ: 3.09 cm × 1.91 cm (1.21 in × 0.75 in), Weight 3.1 g (0.11 oz)\n\nJDR0104022 – Infinity Open Ring with Oval CZ: 1.79 cm × 1.79 cm (0.70 in × 0.70 in), Weight 3.4 g (0.12 oz)\n\nJDR0104025 – Double Bar Ring with Oval CZ: 2.41 cm × 1.78 cm (0.95 in × 0.70 in), Weight 3.4 g (0.12 oz)\n\nJDR0104026 – Organic Frame Ring with Square CZ: 2.11 cm × 1.78 cm (0.83 in × 0.70 in), Weight 3.2 g (0.11 oz)\n\nJDR0104027 – Layered Wave Ring with Round CZ: 1.80 cm × 1.16 cm (0.70 in × 0.46 in), Weight 2.4 g (0.08 oz)\n\nJDR0104032-7 – Minimalist Oval Bezel CZ Ring: 1.37 cm × 1.73 cm (0.53 in × 0.68 in), Weight 4.6 g (0.16 oz), Ring Size US 7\n\nKey Features:\n18K Gold-Plated Stainless Steel\nHigh-Quality Cubic Zirconia Stones\nWaterproof & Tarnish-Resistant\nHypoallergenic – Safe for Sensitive Skin\nModern & Artistic Statement Styles",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:00.152Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
